'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M160 288l-160 0 96-160 122.1 0C301.6-13.4 430.1-7.5 504.6 7.4 519.5 81.9 525.4 210.4 384 293.9l0 122.1-160 96 0-160-64-64zM432 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM152.4 473.6c-45.3 45.3-152 38-152 38s-7.3-106.7 38-152c31.5-31.5 82.5-31.5 114 0s31.5 82.5 0 114zm-40.6-32c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-16.5 16.5-13.8 55.2-13.8 55.2s38.7 2.7 55.2-13.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;